var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.594 18.375c40.733 49.672 27.644 86.682 5.344 122.688.783-42.897-37.23-58.073-83.282-44.032 71.457.144 63.504 53.747 47.25 101.095-8.392 16.15-14.28 33.228-14.28 52.094 0 30.375 13.866 52.983 36.78 67.155-9.875-13.69-13.797-31.204-9.344-51.97 10.182-47.473 52.14-72.297 70.688-112.124 9.593 17.684 24.242 30.335 38.53 30.376 19.437.056 30.155-22.576 25.126-50.812 41.403 59.58 28.32 151.878-11.687 193.875 65.79-30.04 89.29-136.86 44.842-216.783.594 13.805-1.266 27.485-6.187 40.72-10.366-39.618-30.658-94.73-90.78-120.626l-.19-.06c-15.86-5.534-33.44-9.5-52.81-11.595zM358.5 238.53c-23.074 0-41.625 18.543-41.625 41.72S335.425 322 358.5 322c23.074 0 41.594-18.573 41.594-41.75s-18.52-41.72-41.594-41.72zm-88.188 75.75L17.75 468.657v23.938h59.97l237.718-148c-16.89-5.172-32.555-15.733-45.125-30.313z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArson);
export default __webpack_public_path__ + "static/media/arson.35f5098954e5022bef9756df4351f63d.svg";
export { ForwardRef as ReactComponent };